import { render, staticRenderFns } from "./sidepager.vue?vue&type=template&id=453cb8bf&"
import script from "./sidepager.vue?vue&type=script&lang=js&"
export * from "./sidepager.vue?vue&type=script&lang=js&"
import style0 from "./sidepager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports